export default "__VITE_ASSET__DeUsYHzB__"